<template>
  <div>
    <data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination" class="pa-2"></data-list>
    <v-dialog class="custom-scroll" scrollable v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
      <v-card tile>
        <v-card-title class="pa-2" style="background: #036693;color: white">
          <span class="font-weight-bold" :style="$vuetify.theme.dark ? 'color: #dacdcd' : ''"> {{ formProp.id ? $t('message.form.updateFormProps') : $t('message.form.addNewForm') }} </span>
          <v-spacer></v-spacer>
          <v-btn color="success" tile  @click="saveUpdateHandler('SAVE')" dark class="mr-1">{{ formProp.id ? $t('message.common.update') : $t('message.common.save') }}</v-btn>
          <v-btn color="info" tile v-if="formProp.id" class="mx-1"  @click="saveUpdateHandler('UPDATE_CLOSE')" dark>{{ $t('message.common.updateAndClose') }}</v-btn>
          <v-btn class="ml-1" tile color="error" @click="closeDialogHandler()"> {{ $t('message.common.close') }} </v-btn>
        </v-card-title>
        <v-card-text>
          <form-builder :formProp="formProp" v-if="dialog" @update="saveFormData" :token="accessToken"
            @closeForm="closeDialogHandler">
          </form-builder>
        </v-card-text>
      </v-card>
      </v-dialog>
    </div>
</template>
<script>
import DataList from '@/components/DataList.vue'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      total: 0,
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        headers: [],
        list: [],
        loading: false,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler,
        showSettingsBack: true
      },
      dialog: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.FORM_PROPS_INDEX) ? this.$store.state.FORM_PROPS_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'checklisttemplates',
      payload: {
        from: 'forms',
        propid: 0
      },
      formProp: {
        _id: null,
        is_active: true
      },
      apiHeaders: { headers: { 'X-AccessToken': process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN } },
      accessToken: process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN
    }
  },
  components: {
    DataList,
    'form-builder': () => import('@/components/Checklist/FormBuilder.vue')
  },
  computed: {
    ...mapGetters(['listOfModules', 'userDetails']),
    headers () {
      return [{
        text: this.$t('message.props.name'),
        value: 'name',
        isRoute: true,
        isModal: true,
        dbRef: 'name',
        width: '30%'
      }, {
        text: `${this.$t('message.unimicro.createdBy')}`,
        value: 'user_name',
        sortable: false,
        dbRef: 'created_by',
        searchable: false,
        width: '10%'
      }, {
        text: `${this.$t('message.unimicro.updatedOn')}`,
        value: 'updated_on',
        width: '10%'
      }, {
        text: this.$t('message.common.status'),
        value: 'status',
        dbRef: 'status'
      }]
    }
  },
  watch: {
    pagination: {
      handler (val) {
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        let payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE, fromCheckList: false }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.enableEventDeleteListener()
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      let queryFields = this.$formatter.cloneVariable(this.headers)
      queryFields.pop()
      let { page, sortBy, sortDesc, search, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let query = {
        'order_by': {
          'field': sortBy.join(''),
          'asc_or_desc': sortDesc[0] ? 'desc' : 'asc'
        },
        expand: [{
          select: ['firstname', 'lastname'],
          model: 'User',
          on_field: 'id',
          on_parent_field: 'created_by'
        }],
        'skip': ((page - 1) * itemsPerPage),
        'limit': itemsPerPage,
        'include_count': true,
        'filter': `${queryFields.filter(x => x.dbRef).map(x => x.dbRef).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.listPayloadObj.loading = true
      this.$_executeApi('post', `${this.MODULE}/query`, query, this.apiHeaders).then((response) => {
        this.listPayloadObj.list = []
        if (response.data) {
          let { values, count } = response.data
          values.forEach(element => {
            const status = this.listOfStatus.find(x => x.id === element.status)
            if (status) {
              element.status = status.name
            }
            element.updated_on = this.$formatter.formatDate(element.updated_on, 'DD.MM.YYYY HH:mm:SS', 'DD.MM.YYYY HH:mm:SS')
            element.user_name = `${element.user_firstname || ''} ${element.user_lastname || ''}`
          })
          this.listPayloadObj.headers = this.headers
          this.listPayloadObj.list = values
          this.listPayloadObj.loading = false
          this.total = count
        }
      })
    },
    openDialogHandler () {
      this.dialog = true
      this.formProp = { id: null, is_active: true, file: {} }
    },
    closeDialogHandler () {
      this.dialog = false
      this.payload = { from: 'forms', propid: 0 }
      setTimeout(() => {
        this.enableEventDeleteListener()
      })
    },
    getSingleRecordHandler (id) {
      this.$_executeApi('get', `checklisttemplates/${id}`).then(response => {
        this.formProp = response.data
        this.dialog = true
      })
    },
    saveFormData (payload) {
      if (payload.status === 'success') {
        let text = payload.data && payload.action === 'add' ? this.$t('message.common.addedSucess') : this.$t('message.common.updatedSuccess')
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        if (payload.type === 'UPDATE_CLOSE' || payload.action === 'add') this.closeDialogHandler()
        this.getListHandler()
      } else if (payload && payload.status === 'error' && payload.data) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(payload.data) })
      }
    },
    enableEventDeleteListener () {
      this.$eventBus.$on('deleteSuccess', (data) => {
        if (data === this.MODULE) {
          this.listPayloadObj.selection = []
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.deleteMsg') })
          this.$store.commit('hideDialog')
          this.getListHandler()
        }
      })
    },
    saveUpdateHandler (type) {
      this.$root.$emit('saveUpdate', type)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
